export var HistoryActionType;
(function (HistoryActionType) {
    HistoryActionType["ADD"] = "ADD";
    HistoryActionType["ACCEPT"] = "ACCEPT";
    HistoryActionType["UPDATE"] = "UPDATE";
    HistoryActionType["DELETE"] = "DELETE";
    HistoryActionType["LOGIN"] = "LOGIN";
    HistoryActionType["SEARCH"] = "SEARCH";
    HistoryActionType["GET"] = "GET";
})(HistoryActionType || (HistoryActionType = {}));
export const HistoryActionTypeTranslation = {
    [HistoryActionType.ADD]: 'Dodanie',
    [HistoryActionType.ACCEPT]: 'Zatwierdzenie',
    [HistoryActionType.UPDATE]: 'Aktualizacja',
    [HistoryActionType.DELETE]: 'Usunięcie',
    [HistoryActionType.LOGIN]: 'Logowanie',
    [HistoryActionType.SEARCH]: 'Wyszukanie',
    [HistoryActionType.GET]: 'Pobranie'
};
//# sourceMappingURL=historyActionType.enum.js.map